import { format } from 'date-fns'

export function formatHourToString(parameterDate?: string | Date, defaultEmptyString = '') {
  if (!parameterDate) return defaultEmptyString
  return format(new Date(parameterDate), 'HH:mm')
}
